import React from 'react';
import Branch from '../branch';
import Gtag from '../gtag';

const Analytics = () => (
  <div>
    <Branch />
    <Gtag />
  </div>
);

export default Analytics;



// WEBPACK FOOTER //
// ./src/app/applicationServices/analytics/components/Analytics.jsx